import Breakpoints from "Shared/utils/breakpoints"
import { formatCurrencyNumber } from "Shared/utils/helpers"
import ScrollToTop from "Shared/utils/scrollToTop"

import { ColorGenerator } from "./colorGenerator"
import { extractErrors } from "./errorHandler"
import { copyDeeply, insertIf } from "./helpers"
import { getPopupAnchor, usePopUpAnchor } from "./popup.utils"

// prettier-ignore
export {
    Breakpoints,
    extractErrors,
    ScrollToTop,
    copyDeeply,
    insertIf,
    ColorGenerator,
    formatCurrencyNumber,
    getPopupAnchor,
    usePopUpAnchor
};
